{
  "main": {
    "title": "Surface Inspection",
    "subtitle": "Form No. 1 - Surface Inspection Report for Aircraft Movement Areas",
    "titleOddan": "Inspection for today completed",
    "contentOddan": "Today's runway inspection has already been completed. Do you want to submit an additional one?",
    "nazaj": "Back"
  },
  "nav": {
    "vnos": "entry",
    "zapisi": "records"
  },
  "obrazecA": {
    "title": "A. AERODROME",
    "description": "Basic information about the aerodrome",
    "formLabel1": "ICAO code (4 letters)",
    "formLabel2": "Aerodrome name"
  },
  "obrazecB": {
    "title": "B. DATE AND TIME OF INSPECTION (LOCAL TIME)",
    "description": "Time and date of surface inspection",
    "formLabel1": "Date (DD.MM.YYYY)",
    "formLabel2": "Time (HHMM)"
  },
  "obrazecC": {
    "title": "C. RUNWAY DESIGNATOR",
    "description": "Runway identification",
    "formLabel1": "Runway designator (XX-XX)"
  },
  "obrazec1": {
    "title": "1. SURFACE CONDITION",
    "description": "Condition of surfaces in different aerodrome areas",
    "surfaceLabel": "Surface",
    "vse": "all",
    "ploscadi": "Aprons"
  },
  "obrazec3": {
    "title": "3. DEFICIENCIES",
    "description": "Inspection of surface deficiencies",
    "surfaceLabel": "Deficiency",
    "vse": "all",
    "ploscadi": "Aprons"
  },
  "obrazec4": {
    "title": "4. OBSTACLES",
    "description": "Inspection of obstacles on surfaces",
    "surfaceLabel": "Obstacle",
    "vse": "all",
    "ploscadi": "Aprons"
  },
  "obrazec5": {
    "title": "5. PRESENCE OF BIRDS",
    "description": "Inspection of bird presence on surfaces",
    "surfaceLabel": "Bird",
    "gridLabel": "Bird presence",
    "vse": "all",
    "ploscadi": "Aprons"
  },
  "obrazec6": {
    "title": "6. REMARKS",
    "description": "Additional comments and notes",
    "surfaceLabel": "Remark",
    "gridLabel": "Remarks",
    "vse": "all",
    "ploscadi": "Aprons"
  },
  "obrazec7": {
    "title": "7. INSPECTION",
    "description": "Inspection of helicopter landing pads",
    "surfaceLabel": "Inspection",
    "gridLabel": "Helicopter landing pads",
    "vse": "all",
    "vseOK": "all ok",
    "ploscadi": "Aprons"
  },
  "conditions": {
    "dryClean": "a) dry and clean",
    "damp": "b) damp",
    "wet": "c) wet",
    "puddles": "d) puddles",
    "waterLayer": "e) water layer"
  },
  "deficiency": {
    "surfaceDamage": "damage to paved surfaces",
    "foreignObjects": "foreign objects",
    "unevenness": "unevenness exceeding allowable limits",
    "horizontalMarkings": "horizontal markings",
    "verticalMarkings": "vertical markings",
    "safetyStrip": "safety strip and basic runway",
    "other": "other"
  },
  "zapisi": {
    "title": "Surface Inspection Records",
    "description": "Overview of all submitted surface inspection forms",
    "ni": "No records",
    "niDescription": "No surface inspection has been submitted yet. Use the 'Entry' tab to fill in the form.",
    "info": "If you don't see the document, use the download button",
    "posiljam": "Sending..."
  },
  "buttons": {
    "pocisti": "Clear form",
    "poslji": "Submit form",
    "prenesi": "Download document"
  },
    "labels": {
    "datum": "Date"
  },
  "obvestila": {
    "zapisPrihodnost": "The record has a date set in the future, CORRECT the selected date!",
    "zapisCasPrihodnost": "One or more entries have a time set in the future, check the times!",
    "zapisCasNapaka": "The entry times are incorrect! Check the times again!",
    "zapisDodan": "Record successfully added",
    "napakaPristanka": "Landing time cannot be before takeoff time!",
    "zapisPobrisan": "Record successfully deleted",
    "napakaPrazenPristanek": "Input error, landing time cannot be empty",
    "posodobitevUspesna": "Update successful",
    "napakaPosodabljanja": "Error updating data.",
    "napakaBranja": "Error reading data.",
    "napakaIzbrisa": "Error deleting data.",
    "vprasanjeIzbris": "Are you sure you want to delete the record?",
    "napakaVnosaPolja": "Input error, check if all fields are filled!",
    "napakaVnosa": "Error entering data",
    "napakaValidacije": "Field validation error! Check if all fields are filled!",
    "letZakljucen": "Flight successfully completed.",
    "letNiZakljucen": "Error completing the flight."
  }
}